import { render, staticRenderFns } from "./LatestOrderPulls.vue?vue&type=template&id=5e67dbf8"
import script from "./LatestOrderPulls.vue?vue&type=script&lang=js"
export * from "./LatestOrderPulls.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports